<app-card [title]="'user.editUser.labels.additionalInfo'" titleSize="large">
    <ng-template #content>
        @if (form()) {
            @if (errorMsg()) {
                <app-error-float-message>
                    {{ errorMsg() }}
                </app-error-float-message>
            }
            <div class="input-grid-gaps grid-6col p-1">
                <app-date-input
                    id="birthdate"
                    class="fr-2"
                    [prefix]="prefix"
                    [form]="form()"
                    [disabled]="!canEdit()"
                ></app-date-input>

                <app-number-input
                    id="estimatedBirthYear"
                    class="fr-2"
                    label="user.fields.estimatedBirthYear"
                    [form]="form()"
                    [disabled]="!canEdit()"
                ></app-number-input>

                <!-- Info section (is minors and current age) -->
                <div class="fr-2">
                    <div>
                    <span class="font-bold">
                        {{ 'user.fields.minors' | translate }}:
                    </span>
                        {{ minor() ? ('user.common.trueFalseEnum.true' | translate) : ('user.common.trueFalseEnum.false' | translate) }}
                    </div>
                    <div>
                    <span class="font-bold">
                        {{ 'user.fields.currentAge' | translate }}:
                    </span>
                        {{ currentAge() }}
                    </div>
                </div>

                <app-select-input
                    id="nationality"
                    class="fr-3"
                    [prefix]="prefix"
                    [form]="form()"
                    [staticOptions]="nationalityEnumOptions"
                    valueKey="value"
                    [disabled]="!canEdit()"
                    [showClear]="false"
                    [autoDisplayFirst]="false"
                    filterBy="name,value"
                ></app-select-input>

                <app-select-input
                    id="supportMeasures"
                    class="fr-3"
                    [prefix]="prefix"
                    [form]="form()"
                    [staticOptions]="supportMeasureEnumOptions"
                    valueKey="value"
                    [disabled]="!canEdit()"
                    [autoDisplayFirst]="false"
                    [pTooltip]="'user.fields.supportMeasuresTooltip' | translate"
                ></app-select-input>

                <div class="fr-3">
                    <app-select-input
                        id="informationProviderSelect"
                        [prefix]="prefix"
                        [form]="form()"
                        [staticOptions]="infoProviderEnumOptions"
                        valueKey="value"
                        [disabled]="!canEdit()"
                        [autoDisplayFirst]="false"
                    ></app-select-input>

                    @if (form()?.get('informationProviderSelect').value == InfoProviderEnum.OTHER) {
                        <app-text-input
                            id="informationProviderOther"
                            [prefix]="prefix"
                            [form]="form()"
                            [disabled]="!canEdit()"
                        ></app-text-input>
                    }
                </div>

                <app-select-input
                    id="dataVerification"
                    class="fr-3"
                    [prefix]="prefix"
                    [form]="form()"
                    [staticOptions]="dataVerificationEnumOptions"
                    valueKey="value"
                    [disabled]="!canEdit()"
                    [autoDisplayFirst]="false"
                ></app-select-input>

                <app-text-input
                    id="verificationNumber"
                    [prefix]="prefix"
                    [form]="form()"
                    [disabled]="!canEdit()"
                ></app-text-input>

                <app-number-input
                    id="personNumber"
                    [prefix]="prefix"
                    [form]="form()"
                    [disabled]="!canEdit()"
                    class="fr-1"
                ></app-number-input>

                <app-check-input
                    id="foreigner"
                    class="fr-1"
                    [form]="form()"
                    [disabled]="!canEdit()"
                ></app-check-input>

                <app-date-input
                    id="dateDeath"
                    class="fr-2"
                    [prefix]="prefix"
                    [form]="form()"
                    [disabled]="!canEdit()"
                    [maxDate]="today"
                ></app-date-input>
            </div>
        }
    </ng-template>
</app-card>
